export const getInheritedIraReviewNextPage = (): string => 'secure/inherited-ira/terms/new';
export const getInheritedIraTermsNextPage = (): string => 'secure/inherited-ira/confirm';
